/**
 * Feature flags enum
 *
 * Defines all toggleable capabilities in the system.
 * This file represents the contract layer and should be stable.
 *
 * Changes here usually require engineering review because they affect system design.
 */
export enum Feature {
  PASSKEY_AUTH = 'passkeyAuth',
  PAYMENT = 'payment',
  BATCH_PAYMENT = 'batchPayment',
  SELECTED_ACCOUNT = 'selectedAccount',
  MANAGE_PAYMENT = 'managePayment',
  IRD_SCHEDULE = 'irdSchedule',
  TEAM_MEMBERS = 'teamMembers',
  CARDS = 'cards'
}

/**
 * Release mode for a feature flag.
 *
 * - PUBLIC: visible to every user once `enabled` is true (default when omitted).
 * - INTERNAL: visible only to users whose login/customer email matches an allowed
 *   internal domain, even when `enabled` is true. Lets a feature be shipped to prod
 *   and verified by internal testers before it's opened up publicly.
 */
export enum ReleaseMode {
  PUBLIC = 'public',
  INTERNAL = 'internal'
}

/**
 * Feature flag configuration contract.
 *
 * Runtime state (enabled/disabled) lives in `featureFlags.state.ts`, but shares this type
 * to keep a consistent shape (and documentation) across the app.
 */
export type FeatureFlagDefinition = {
  enabled: boolean;
  description: string;
  releaseMode?: ReleaseMode;
};
